//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { applySnapshot, flow, getEnv, getSnapshot } from "mobx-state-tree";
import { FormStepType, RootStore } from "..";
import { STEPS } from "../utils";

export const EditTutorInfo = RootStore.named("EditTutorInfo").actions(
  (self) => {
    let { adapter } = getEnv(self);
    const initWithStaticData = ({ regions, countries, countriesSupported }) => {
      self.locationInfo.updateFields({
        regions,
        countries,
        countriesSupported,
      });
    };
    const updateEditTutorStore = (data) => {
      self.slug = data.userId;
      applySnapshot(self.personalInfo, data);
      // self.personalInfo = {...data,};
      self.schedule.updateFields({
        availability: data.availability,
        maxHours: data.maxHours,
        maxDays: data.maxDays,
        maxStudents: data.maxStudents,
        preferredLessonType: data.delivery || data.preferredLessonType,
        exemptedAreas: data.exemptedAreas,
      });
      self.locationInfo.updateFields({
        country: data.country,
        state: data.state,
        region: data.region,
        vicinity: data.vicinity,
        address: data.address,
        supportedCountryAccount: data.country,
        lessonType: data.delivery,
        exemptedAreas: data.exemptedAreas,
      });
      self.fetchBanksInfo();
      self.paymentInfo.updateFields({
        bankName: data.paymentInfo?.bankName,
        accountName: data.paymentInfo?.accountName,
        accountNumber: data.paymentInfo?.accountNumber,
      });
      self.paymentInfo.sortCode = data.paymentInfo?.sortCode;
      self.paymentInfo.taxId = data.paymentInfo?.taxId;
    };

    function personalInfoSubmission(formData: any) {
      self.personalInfo.onFormSubmit(formData);
      let { lessonType, exemptedAreas, ...rest } = self.locationInfo.formValues;
      return {
        phone: self.personalInfo.formValues.phone,
        whatsappNumber: self.personalInfo.formValues.whatsappNumber,
      };
    }

    function locationInfoSubmission(formData: any) {
      self.locationInfo.updateFields(formData);
      if (formData.lessonType.toJSON) {
        self.schedule.setPreferredLessonType(getSnapshot(formData.lessonType));
      }
      self.fetchBanksInfo();

      return {
        ...self.personalInfo.formValues,
        ...self.locationInfo.formValues,
      };
    }

    function scheduleSubmission(formValues: any) {
      self.schedule.saveData(formValues);
      return self.schedule.formValues;
    }

    function paymentInfoSubmission(formData) {
      self.paymentInfo.updateFields(formData);
      return self.paymentInfo.formValues;
    }

    const onTutorFormSubmit = flow(function* onFormSubmit(formData, key) {
      const options = {
        [STEPS.PERSONAL_INFO]: personalInfoSubmission,
        [STEPS.LOCATION_INFO]: locationInfoSubmission,
        [STEPS.SCHEDULE_INFO]: scheduleSubmission,
        [STEPS.PAYMENT_INFO]: paymentInfoSubmission,
      };
      self.loading = true;
      try {
        let data: any = options[key](formData);
        yield adapter.editTutorInfo({
          key,
          data,
          slug: self.slug,
          email: self.personalInfo.email,
        });
        self.loading = false;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });

    return {
      onTutorFormSubmit,
      initWithStaticData,
      updateEditTutorStore,
    };
  },
);

export default EditTutorInfo;
